export class UpdatePrivateLinkInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fqdn",
            "baseName": "fqdn",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupRules",
            "baseName": "securityGroupRules",
            "type": "Array<SecurityGroupRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdatePrivateLinkInput.attributeTypeMap;
    }
    constructor() {
    }
}
